<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BForm,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import TabCliente from '@/views/cadastros/cliente/cliente/list/TabCliente.vue';
import TabComercial from '@/views/cadastros/cliente/cliente/list/TabComercial.vue';
import TabContato from '@/views/cadastros/cliente/cliente/list/TabContato.vue';
import TabDocumento from '@/views/cadastros/cliente/cliente/list/TabDocumento.vue';
import TabEndereco from '@/views/cadastros/cliente/cliente/list/TabEndereco.vue';
import TabFiscal from '@/views/cadastros/cliente/cliente/list/TabFiscal.vue';
import TabRepresentante from '@/views/cadastros/cliente/cliente/list/TabRepresentante.vue';
import TabDadosUsuario from '@/views/sistema/usuarios/list/TabDadosUsuario.vue';
import TabPerfilAcesso from '@/views/sistema/usuarios/list/TabPerfilAcesso.vue';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BFormInput,
    BForm,
    TabPerfilAcesso,
    TabDadosUsuario,
    TabCliente,
    TabComercial,
    TabContato,
    TabDocumento,
    TabEndereco,
    TabFiscal,
    TabRepresentante,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        usuario_email: '',
        usuario_nome: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      isLoading: false,
      dataFromApiPerfilsAcesso: [],
      isEmailVerifying: false,
      emailExists: false,
      tenants: [],
      selectedTenantSlug: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isDkpAdmin() {
      const tenantSlug = localStorage.getItem('tenantSlug') || '';
      return tenantSlug === 'dkp';
    },
  },
  watch: {
    'dataForm.usuario_email': {
      handler(newValue) {
        this.emailExists = false;

        if (this.emailCheckTimeout) clearTimeout(this.emailCheckTimeout);

        if (newValue && newValue.includes('@')) {
          this.emailCheckTimeout = setTimeout(() => {
            this.verificarEmailExistente(newValue);
          }, 500);
        }
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },

  methods: {
    buildTenantHeaders() {
      if (this.isDkpAdmin && this.selectedTenantSlug) {
        return { 'x-admin-view-tenant': this.selectedTenantSlug };
      }
      return {};
    },

    async verificarEmailExistente(email) {
      if (!email) return;

      this.isEmailVerifying = true;
      try {
        const response = await axios.get(`/usuarios/findAll?q=${encodeURIComponent(email)}`, {
          headers: this.buildTenantHeaders(),
        });
        if (response.data.total === 0) {
          this.emailExists = false;
        } else {
          this.emailExists = true;
        }
      } catch (error) {
        console.error('Erro ao verificar email:', error);
      } finally {
        this.isEmailVerifying = false;
      }
    },

    async criarUsuario() {
      const isValid = await this.$refs.refFormData.validate();
      if (!isValid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Verifique os campos do formulário',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.isLoading = true;
      if (this.dataForm.usuario_email === '' || this.dataForm.usuario_nome === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Preencha os campos obrigatórios',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoading = false;
        return;
      }

      if (this.dataForm.id_perfil_acesso === null || this.dataForm.id_perfil_acesso === undefined || this.dataForm.id_perfil_acesso === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Selecione o perfil de acesso inicial',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoading = false;
        return;
      }

      if (this.emailExists) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Este e-mail já está cadastrado no sistema',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      try {
        const response = await axios.post('/usuarios/create', this.dataForm, {
          headers: this.buildTenantHeaders(),
        });
        console.log(response);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Usuário criado',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        this.isLoading = false;
        this.$refs.modalAdd.hide();
        this.dataForm = '';
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao criar usuário',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
        location.reload();
      }
    },

    async fetchDataFromPerfilsAcesso() {
      try {
        const response = await axios.get('/perfilAcesso/findAll');
        this.dataFromApiPerfilsAcesso = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },

    async fetchTenants() {
      try {
        const response = await axios.get('/tenants');
        this.tenants = response.data || [];
        const currentImpersonate = localStorage.getItem('dkpImpersonateSlug');
        if (currentImpersonate && currentImpersonate !== 'dkp') {
          this.selectedTenantSlug = currentImpersonate;
        } else {
          this.selectedTenantSlug = 'dkp';
        }
      } catch (error) {
        console.error('Erro ao carregar tenants:', error);
        this.tenants = [];
      }
    },

    onModalShow() {
      this.fetchDataFromPerfilsAcesso();
      if (this.isDkpAdmin) {
        this.fetchTenants();
      }
    },

    fecharModal() {
      this.$refs.modalAdd.hide();
      this.dataForm = '';
      this.emailExists = false;
    },
  },
};
</script>

<template>
  <b-modal ref="modalAdd" no-close-on-backdrop no-close-on-esc size="xl" :id="idModal" :title="titleModal"
    ok-variant="success" cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar"
    @cancel="$emit('cancel')" @close="$emit('cancel')" hide-footer>
    <b-overlay :show="isLoading">
      <validation-observer ref="refFormData">
        <b-form @submit.prevent>
          <b-row>
            <b-col v-if="isDkpAdmin" cols="12" md="12">
              <b-form-group label="Tenant (Empresa)" label-for="tenant_selector">
                <v-select
                  id="tenant_selector"
                  v-model="selectedTenantSlug"
                  :options="tenants"
                  label="nome"
                  :reduce="t => t.slug"
                  placeholder="Selecione o tenant..."
                  :clearable="false"
                />
                <small class="text-muted">O usuário será criado para o tenant selecionado.</small>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group label="Nome" label-for="username">
                <b-form-input id="username" v-model="dataForm.usuario_nome" />
              </b-form-group>
            </b-col>
            <!-- Field: Email -->
            <b-col cols="12" md="12">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="dataForm.usuario_email"
                    type="email"
                    :state="dataForm.usuario_email ? (!emailExists && !errors.length) : null"
                  />
                  <b-form-invalid-feedback v-if="emailExists">
                    Este e-mail já está cadastrado no sistema.
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback v-else-if="errors.length">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                  <div v-if="isEmailVerifying" class="text-muted">
                    <b-spinner small class="mr-1"></b-spinner>
                    <small>Verificando e-mail...</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Autenticação Integrada (AD)" label-for="usuario_autentica_ad">
                <b-form-checkbox v-model="dataForm.usuario_autentica_ad"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :clearable="false"
                  input-id="usuario_autentica_ad" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <validation-provider #default="{ errors }" name="Perfil Acesso Inicial" rules="required">
                <b-form-group label="Perfil Acesso Inicial" label-for="id_perfil_acesso">
                  <b-form-select v-model="dataForm.id_perfil_acesso" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="dataFromApiPerfilsAcesso" text-field="perfil_acesso_nome" value-field="id"
                    :clearable="false" input-id="id_perfil_acesso"
                    :state="errors.length ? false : null" />
                  <b-form-invalid-feedback :state="errors.length ? false : null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
        <div class="mt-2">
          <b-button variant="primary" class="mr-1 mb-sm-0 mr-0 mr-sm-1" @click="criarUsuario()"
            :disabled="emailExists || isEmailVerifying">
            Salvar Alterações
          </b-button>
          <b-button variant="outline-secondary" type="reset" @click="fecharModal()">
            Cancelar
          </b-button>
        </div>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>
